import React from 'react';
import './Chapters.scss';
import PullQuote from '../PullQuote/PullQuote';

function Chapter2() {
  return (
    <>
      <section className="chapter">
        <p className="chapter__title">Life in Miller’s Landing </p>
        <p className="chapter__paragraph">
          According to the project’s site, Miller’s Landing is a SmartTown with “a design philosophy
          and method that focuses on user needs to scale smart-city technology to smaller mixed-use
          developments.” In practice, that means that no matter where you go on the scenic 65-acre
          development, you’re always connected. This is thanks to a vast cloud architecture that
          manages various aspects of its living and working spaces at lightning-fast speeds. Intel,
          together with its partners, are working to provide a robust, redundant converged network
          that supports multiple carriers as a centerpiece of the SmartTown and its capabilities.
        </p>
        <p className="chapter__paragraph">
          “The key pillar within this project is the low-latency and future-enabled networking
          capabilities,” Ilhan says. “Basically, a whole micro-city has to be connected from
          different aspects—a hospitality space, a retail space, healthcare spaces, and outdoor
          spaces.”
        </p>
      </section>
    </>
  );
}

export default Chapter2;
